/**
 * Splits a station opening-hours string into display lines.
 * Midday closures come as comma-separated ranges (e.g. "08:00 - 12:00, 14:00 - 18:00").
 * Single windows and translated "Closed" strings are returned as a single line.
 */
export const getOpeningHoursDisplayLines = (hours: string): string[] => {
  if (!hours || typeof hours !== "string") return [];
  return hours
    .split(", ")
    .map(line => line.trim())
    .filter(Boolean);
};
